import { WorkspaceUserWithRole } from '@/models/workspace';
import { ColumnDef } from '@tanstack/react-table';
import { createUserActionsColumn } from './UserActionsColumn';
import { userEmailColumn } from './UserEmailColumn';
import { userRoleColumn } from './UserRoleColumn';

export const getWorkspaceUsersTableColumns = (
  canDelete: boolean = false,
  onDeleteClick?: (user: WorkspaceUserWithRole) => void
): ColumnDef<WorkspaceUserWithRole>[] => {
  const columns: ColumnDef<WorkspaceUserWithRole>[] = [userEmailColumn, userRoleColumn];

  if (canDelete && onDeleteClick) {
    columns.push(createUserActionsColumn(canDelete, onDeleteClick));
  }

  return columns;
};